const clearTimeouts = () => {
    var id = window.setTimeout(() => {}, 0);

    while (id--) {
        window.clearTimeout(id);
    }
}
const throwPopupEvent = (obj) => {
    window.dispatchEvent(new CustomEvent("showpopup", {
        "detail": obj
    }));
}

export {
    clearTimeouts,
    throwPopupEvent
}


// WEBPACK FOOTER //
// ./src/Components/Services/Timing.js